var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/babel-polyfill/~/core-js/modules/_wks.js
 ** module id = 25
 ** module chunks = 0
 **/